import React from "react";
import { useHistory } from "react-router-dom";
import { CircleCheck, CirclePlus } from "../TableIcons/TableIcons";
import styles from "./MyTeamTable.module.css";

const MyTeamTable = (props) => {
  const history = useHistory();
  const onClickOneToOne = (e, oneToOne, userEmail) => {
    e.stopPropagation();
    const { id, period, financialYear } = oneToOne;
    let url = `/my-team/${userEmail}/view-1-2-1`;

    if (!id) {
      url = `${url}/${financialYear.replace("/", "-")}/${period}`;
    } else {
      url = `${url}/${id}`;
    }
    history.push(url);
  };

  return (
    <table className={styles.TableView} summary="My Team Table">
      <tbody>
        <tr role="row">
          <th className={styles.title}>Team Member</th>
          <th className={styles.title}/>
          {props.tableData &&
            props.tableData[0].oneToOnes &&
            props.tableData[0].oneToOnes.map((item, index) => (
              <th className={styles.periodTitle} key={index}>
                {item.period}
              </th>
            ))}
        </tr>
        {props.tableData &&
          props.tableData.map((item) => (
            <tr name={item.email} key={item.email} className={styles.data_row}>
              <td
                id="tabToMe"
                role="link"
                tabIndex={0}
                onClick={() => {
                  history.push(`/my-team/${item.email}/oneToOnes`);
                }}
                onKeyDown={(e) =>
                  e.key === "Enter" ? history.push(`/my-team/${item.email}/oneToOnes`) : null
                }
              >
                {item.name}
              </td>
              <td
                role="link"
                className={styles.job_title}
                onClick={() => {
                  history.push(`/my-team/${item.email}/oneToOnes`);
                }}
                onKeyDown={(e) =>
                  e.key === "Enter" ? history.push(`/my-team/${item.email}/oneToOnes`) : null
                }
              >
                {item.jobtitle}
              </td>
              {item.oneToOnes.map((oneToOne, index) => (
                <td
                  aria-label={oneToOne.oneToOneComplete ? "complete" : "incomplete"}
                  tabIndex={0}
                  key={index}
                  role="button"
                  name={`go to ${oneToOne.oneToOneComplete ? "complete" : "incomplete"} one to one`}
                  onClick={(e) => onClickOneToOne(e, oneToOne, item.email)}
                  onKeyDown={(e) =>
                    e.key === "Enter" ? onClickOneToOne(e, oneToOne, item.email) : null
                  }
                >
                  {oneToOne.oneToOneComplete ? <CircleCheck /> : <CirclePlus />}
                </td>
              ))}
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default MyTeamTable;
